lmApp
  .directive('lmDuration', ['$timeout', 'KeyService', function ($timeout, KeyService) {
    return {
      restrict: 'E',
      scope: {
        ngModel: '=',
        ngDisabled: '=?'
      },
      link: function (scope, element, attrs) {
        scope.ngModel = +scope.ngModel || 0;
        scope._duration_element_ = element;
        scope._edit_ = element.find('#editable');
        scope._inputs_ = element.find('.ninja.showen');
        scope._empty_ = angular.element('<div id="empty" style="opacity: 0.6; height: 500%;"></div>');
        scope.hours = parseInt(scope.ngModel / 3600, 10);
        scope.minutes = parseInt(scope.ngModel / 60 % 60, 10);
        scope.seconds = parseInt(scope.ngModel - (scope.hours * 3600 + scope.minutes * 60), 10);
        scope.active = 0;

        /**
         * [NG-WATCH] Watch for model change and replace with correct value
         * @type {function()}
         */
        var watch = scope.$watch('ngModel', function (newValue, oldValue) {
          $timeout(function () {
            scope.hours = parseInt(scope.ngModel / 3600, 10);
            scope.minutes = parseInt(scope.ngModel / 60 % 60, 10);
            scope.seconds = parseInt(scope.ngModel - (scope.hours * 3600 + scope.minutes * 60), 10);

            if (scope.hours < 10) {
              scope.hours = '0' + scope.hours;
            }
            if (scope.minutes < 10) {
              scope.minutes = '0' + scope.minutes;
            }
            if (scope.seconds < 10) {
              scope.seconds = '0' + scope.seconds;
            }
          });
        });

        /**
         * Add "0": 0..9  |->  00 .. 09
         */
        if (scope.hours < 10) {
          scope.hours = '0' + scope.hours;
        }
        if (scope.minutes < 10) {
          scope.minutes = '0' + scope.minutes;
        }
        if (scope.seconds < 10) {
          scope.seconds = '0' + scope.seconds;
        }

        /**
         * Set correct value for minutes, seconds: 00..59
         * @param string
         * @param type
         * @returns {Number|*}
         * @private
         */
        var _Parse = function (string, type) {
          string = string.toString().replace(/\D+/g, '').substring(0, 2);
          if (!string.length) string = '00';
          string = parseInt(string, 10);

          if (string < 10) {
            string = '0' + string;
          } else {
            switch (type) {
              case 'hours':
                //if (string > 23) string = '00';
                break;

              case 'minutes':
                if (string > 59) string = '00';
                break;

              case 'seconds':
                if (string > 59) string = '00';
                break;

              default:
                string = '00';
                break;
            }
          }

          return string;
        };

        /**
         * [EVENT HANDLER] Parse full model after changes, when user click on input field
         * @param event
         * @private
         */
        var _ClickInput = function (event) {
          if (event.preventDefault) event.preventDefault();
          if (event.stopPropagation) event.stopPropagation();

          var id = event.target.attributes.id.value;

          $timeout(function () {
            scope.hours = _Parse(scope.hours, 'hours');
            scope.minutes = _Parse(scope.minutes, 'minutes');
            scope.seconds = _Parse(scope.seconds, 'seconds');
          });

          if (id === 'hours') scope.active = 0;
          if (id === 'minutes') scope.active = 1;
          if (id === 'seconds') scope.active = 2;

          event.target.focus();
          event.target.select();
        };

        /**
         * [EVENT HANDLER] Parse full model after changes, when user click on widget
         * @param event
         * @private
         */
        var _ClickElement = function (event) {
          $timeout(function () {
            scope.hours = _Parse(scope.hours, 'hours');
            scope.minutes = _Parse(scope.minutes, 'minutes');
            scope.seconds = _Parse(scope.seconds, 'seconds');
          });
        };

        /**
         * [EVENT HANDLER] Keyboard events
         * @param event
         * @private
         */
        var _Navigation = function (event) {
          var key = event.which;

          if (key === KeyService.Keys.TAB) {
            if (event.preventDefault) event.preventDefault();
            if (event.stopPropagation) event.stopPropagation();

            $timeout(function () {
              scope.hours = _Parse(scope.hours, 'hours');
              scope.minutes = _Parse(scope.minutes, 'minutes');
              scope.seconds = _Parse(scope.seconds, 'seconds');
            });

            scope.active++;
            if (scope.active > 2) {
              scope.active = 0;
              scope._inputs_[scope.active].focus();
              scope._inputs_[scope.active].select();
            } else {
              scope._inputs_[scope.active].focus();
              scope._inputs_[scope.active].select();
            }
          }

          if (key === KeyService.Keys.ENTER) {
            if (event.preventDefault) event.preventDefault();
            if (event.stopPropagation) event.stopPropagation();
            _CloseEdit()
          }

          if (key === KeyService.Keys.ESCAPE) {
            if (event.preventDefault) event.preventDefault();
            if (event.stopPropagation) event.stopPropagation();
            _CloseEdit();
          }

          if (key === KeyService.Keys.ARROW_DOWN) {
            if (event.preventDefault) event.preventDefault();
            if (event.stopPropagation) event.stopPropagation();

            $timeout(function () {
              scope.minus(scope[event.target.attributes.id.value], event.target.attributes.id.value);
              event.target.focus();
              event.target.select();
            });
          }

          if (key === KeyService.Keys.ARROW_UP) {
            if (event.preventDefault) event.preventDefault();
            if (event.stopPropagation) event.stopPropagation();

            $timeout(function () {
              scope.plus(scope[event.target.attributes.id.value], event.target.attributes.id.value);
              event.target.focus();
              event.target.select();
            });
          }
        };

        /**
         * [EVENT HANDLER] Keyboard events
         * @param event
         * @private
         */
        var _OnKeyDown = function (event) {
          var key = event.which;

          if (key === KeyService.Keys.ESCAPE) {
            if (event.preventDefault) event.preventDefault();
            if (event.stopPropagation) event.stopPropagation();

            _CloseEdit();
            return;
          }
        };

        /**
         * [DOM] Show input widget: [NG-IF] property change
         * @private
         */
        scope.openEdit = function () {
          if (scope.ngDisabled) return;

          //scope._edit_.unbind('click', _OpenEdit);
          scope._inputs_.bind('keydown', _Navigation);
          scope._inputs_.bind('click', _ClickInput);
          scope._empty_.appendTo(scope._duration_element_);

          $timeout(function () {
            scope._edit_.css({'z-index': 9999});
            scope._empty_.css({'z-index': 9998});
            scope.inputShowen = true;
            scope._inputs_[scope.active].focus();
            scope._inputs_[scope.active].select();
          });

          scope._duration_element_.bind('click', _ClickElement);
          scope._empty_.bind('click', _CloseEdit);
          angular.element('body').bind('keydown', _OnKeyDown);
        };

        /**
         * [DOM] Hide input widget: [NG-IF] property change
         * @private
         */
        var _CloseEdit = function () {
          $timeout(function () {
            scope.inputShowen = false;
            scope.ngModel = parseInt(scope.seconds, 10) + parseInt(scope.hours, 10) * 3600 + parseInt(scope.minutes, 10) * 60;
          });

          scope._inputs_[scope.active].blur();

          //scope._edit_.bind('click', _OpenEdit);
          scope._duration_element_.unbind('click', _ClickElement);
          scope._inputs_.unbind('keydown', _Navigation);
          scope._inputs_.unbind('click', _ClickInput);
          scope._empty_.unbind('click', _CloseEdit);
          scope._empty_.remove();
          angular.element('body').unbind('keydown', _OnKeyDown);
        };

        //scope._edit_.bind('click', _OpenEdit);

        scope.closeEdit = function () {
          $timeout(function () {
            scope.hours = _Parse(scope.hours, 'hours');
            scope.minutes = _Parse(scope.minutes, 'minutes');
            scope.seconds = _Parse(scope.seconds, 'seconds');
          });

          _CloseEdit();
        };

        /**
         * [NG-CLICK, EVENT HANDLER] Add +1
         * @param value
         * @param type
         */
        scope.plus = function (value, type) {
          scope[type] = _Parse(Number(value) + 1, type);
        };

        /**
         * [NG-CLICK, EVENT HANDLER] Remove -1
         * @param value
         * @param type
         */
        scope.minus = function (value, type) {
          if (Number(value) - 1 < 0) {
            scope[type] = (type === 'hours') ? _Parse(0, type) : _Parse(59, type);
          } else {
            scope[type] = _Parse(Number(value) - 1, type);
          }
        };

        /**
         * Clear global scope
         */
        scope._duration_element_.on('$destroy', function () {
          watch();
          scope.$destroy();
        })

      },
      templateUrl: 'lm-duration/lm-duration.tpl.html'
    }
  }]);
